import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  exportTimeKeepingManagerStart,
  exportTimeKeepingManagerSuccess,
  exportTimeKeepingManagerFailed,
} from "../redux/exportTimeKeepingManager";

import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterTimeKeepingManagerSelector } from "../redux/selector";
import { exportTimeKeepingManagerApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";

function* exportTimeKeepingManagerWork() {
  const form = yield select(formFilterTimeKeepingManagerSelector);

  const params = { ...form };
  try {
    const res = yield call(exportTimeKeepingManagerApi, {
      ...params,
      screenCode: SCREEN.IP_019,
    });

    const blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `Bảng_tổng_hợp_chấm_công_24/${form?.month - 1}-24/${form?.month}.xlsx`; // Name of the file to download

    // Append link to body and trigger download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put({
      type: exportTimeKeepingManagerSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: exportTimeKeepingManagerFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportTimeKeepingManager() {
  yield takeLatest(
    exportTimeKeepingManagerStart.type,
    exportTimeKeepingManagerWork
  );
}

export default function* exportTimeKeepingManagerSaga() {
  yield all([watchExportTimeKeepingManager()]);
}
